<template>
  <div>
    <step :navItems="navItems" :index="1" :step="step" v-on:step="updateStep" v-on:back="() => { this.$router.push('/course-mgr') }">
      <template slot="header">
        <h3>{{$t('coursework_list_name')}}</h3>
      </template>

      <template slot="body">
        <div class="row">
          <div class="col-sm-4 offset-sm-4">
            <form class="form-custom bg-white">
              <label for="inputOldPassword" class="sr-only">{{$t('coursework_list_name')}}</label>
              <input type="text" class="form-control mt-3 rounded" :placeholder="$t('Please_enter_name')" required v-model="name">
            </form>
          </div>
        </div>
      </template>
    </step>

    <step :navItems="navItems" :index="2" :step="step" v-on:step="updateStep">
      <template slot="header">
        <div class="row">
          <div class="col-sm-4">
            <ul class="nav" v-if="switchOn">
              <li class="nav-item dropdown border rounded mr-1">
                <a class="nav-link dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                  {{ language }}
                </a>
                <div class="dropdown-menu">
                  <a class="dropdown-item"
                    v-for="(filter, index) in lessonFilters" :key="index"
                    @click="update(index)">{{ filter.languageName }}</a>
                </div>
              </li>
              <li v-if="lessonFilters[currentIndex]" class="nav-item dropdown border rounded mr-1">
                <a class="nav-link dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                  {{ category }}
                </a>
                <div class="dropdown-menu" v-if="lessonFilters[currentIndex]">
                  <a class="dropdown-item"
                    v-for="(category, index) in lessonFilters[currentIndex].categories" :key="index"
                    @click="getLessonList({ categoryId: category.Key })">
                    {{ category.Value }}
                  </a>
                </div>
              </li>
              <li v-if="lessonFilters[currentIndex]" class="nav-item dropdown border rounded">
                <a class="nav-link dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" >
                  {{ level }}
                </a>
                <div class="dropdown-menu" v-if="lessonFilters[currentIndex]">
                  <a class="dropdown-item"
                    v-for="(level, index) in lessonFilters[currentIndex].levels" :key="index"
                    @click="getLessonList({ level: level })">{{ level }}</a>
                </div>
              </li>
            </ul>
          </div>
          <div class="col-sm-4" style="font-size: 24px;">{{ name }}</div>
          <div class="col-sm-4">
            <switch-button v-on:status="(status) => { this.switchOn = status }" :leftLabel="$t('all_courses')" :rightLabel="$t('selected_courses')" />
          </div>
        </div>
      </template>

      <template slot="body">
        <div class="row mt-3">
          <div class="col-8 offset-2">
            <ul class="list-group list-group-flush">
              <li class="list-group-item border text-left mb-3 rounded"
                :class="{ 'active': getSelectedIdx(lesson.id) > -1 }"
                style="line-height: 150%;"
                v-for="lesson in lessons"
                :lang="lesson.language"
                @click="select(lesson)">
                <div class="float-left">
                  <span v-html="forceToJap(lesson.name)"></span><br>{{ lesson.localName }}
                </div>
                <div class="float-right" style="line-height: 300%;">
                  <span class="p-0 pl-3 pr-3 text-white btn-category content" v-if="lesson.language">{{ lesson.language }}</span>
                  <span class="p-0 pl-3 pr-3 text-white btn-category user-target" v-if="lesson.categoryName">{{ lesson.categoryName }}</span>
                  <span class="p-0 pl-3 pr-3 text-white btn-category level" v-if="lesson.level">{{ lesson.level }}</span>
                </div>
              </li>
            </ul>

            <pagination class="mt-3" :current="lessonList.pageIndex" :total="lessonList.pageCount" v-on:page="updatePage" v-if="switchOn" />
          </div>
        </div>
      </template>
    </step>

    <step :navItems="navItems" :index="3" :step="step" v-on:step="updateStep" v-on:back="() => { this.$router.push('/course-mgr') }" v-on:finish="() => { this.$router.push('/course-mgr') }">
      <template slot="header">
        <h3>{{$t('_finish')}}</h3>
      </template>

      <template slot="body">
        <div class="col-8 offset-2">
          <ul class="list-group list-group-flush">
            <li class="list-group-item border text-left mb-3 rounded"
              style="line-height: 150%;">
              <span>
                {{ name }}<br>{{$t('generated_time')}}：{{ createTime }}
              </span>
              <span class="float-right">
                {{$t('course',{count: selected.length})}}
              </span>
            </li>
          </ul>
        </div>
      </template>
    </step>
  </div>
</template>

<script>
import lessonFilterMixin from '../../components/lessonFilterMixin'
import langMixin from '../../components/langMixin'
import Pagination from '../../components/Pagination'
import Step from './Step'
import api from '../../store/api'
import selectMixin from './selectMixin'
import SwitchButton from './SwitchButton'

export default {

  name: 'TeachingCourseEditor',

  components: {
    Pagination,
    Step,
    SwitchButton
  },

  mixins: [lessonFilterMixin, langMixin, selectMixin],

  data () {
    return {
      step: 1,
      switchOn: true,
      courseId: null,
      name: '',
      createTime: '',
      defaultTitle: {
        language: this.$t('_language'),
        category: this.$t('_category'),
        level: this.$t('_level')
      },
      navItems: [this.$t('add_or_select_list'), this.$t('input_name'), this.$t('select_course'), this.$t('_finish')]
    }
  },

  computed: {
    mode () {
      return (this.$route.name === 'course-mgr.add') ? 'add' : 'edit'
    },

    lessons () {
      return this.switchOn ? this.lessonList.list : this.selected
    }
  },

  async mounted () {
    this.courseId = this.$route.params.courseId
    this.getLessonFilters()
    this.getLessonList()
    console.log(this.lessonFilters[this.currentIndex])

    if (this.courseId) {
      const { data } = await api.get('/CourseMgr/TeachingCourse/' + this.courseId)

      if (data.status === 'OK') {
        this.name = data.data.name
        this.createTime = data.data.createTime

        let self = this
        api.get('/CourseMgr/TeachingCourse/' + this.courseId + '/Lessons')
          .then((res) => {
            self.selected = res.data.data || []
          })
      }
    }
  },

  methods: {
    updatePage (page) {
      this.getLessonList({
        'pageIndex': page
      })
    },
    update (params) {
      let lang = params ? 'Ja' : 'En'
      this.getLessonList({language: lang})
    },
    async updateStep (step) {
      if (step === 2) {
        let formData = new window.FormData()
        formData.append('name', this.name)

        if (this.mode === 'add') {
          const { data } = await api.post('/CourseMgr/TeachingCourse', formData)
          if (data.status === 'OK') {
            this.courseId = data.data.id
          }
        } else {
          const { data } = await api.patch('/CourseMgr/TeachingCourse/' + this.courseId, formData)
          if (data.status === 'OK') {
            this.courseId = data.data.id
          }
        }
      }

      this.step = step
    },

    async select (item) {
      let idx = this.getSelectedIdx(item.id)
      let dataForm = new window.FormData()
      dataForm.append('lessonIds', [item.id])

      if (idx > -1) {
        const { data } = await api.delete('/CourseMgr/TeachingCourse/' + this.courseId + '/Lessons', dataForm)

        if (data.status === 'OK') {
          this.selected.splice(idx, 1)
        }
      } else {
        const { data } = await api.post('/CourseMgr/TeachingCourse/' + this.courseId + '/Lessons', dataForm)

        if (data.status === 'OK') {
          this.selected.push(item)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/color.scss';

.list-group-item.active {
  background-color: $main-color;
}

h3 {
  font-size: 20px;
}
</style>


// WEBPACK FOOTER //
// TeachingCourseEditor.vue?e4ee9c5a